import qs from 'query-string'
import useRouter from 'use-react-router'
import {useEvent} from 'util/eventcontext'

export const useIsDark = () => {
	const event = useEvent()
	return event.isDarkTheme
}

export const useSearchParams = () => {
	const router = useRouter()
	return getSearchParamsFromRouter(router)
}

export const getSearchParamsFromRouter = router => {
	return qs.parse(router.location.search)
}

export const routeToParams = (router, params: Record<string, any>) => {
	const paramsString = qs.stringify(params)
	const url = location.pathname + (paramsString ? '?' + paramsString : '')
	router.history.push(url)
}
